<template>
  <div class="bg-white">
    <LeftSideBar
        v-if="!this.hiddenSideBar"
        v-model="this.sideBarMenus"
        :collapsed-menu-default="true"
        class="position-absolute"
        @closed="() => {
          this.hiddenSideBar = true
        }"
    />

    <div>
      <div class="d-flex flex-wrap justify-content-between p-2">
        <Button
            icon="pi pi-bars"
            class="rounded"
            severity="secondary"
            @click="() => {
              this.hiddenSideBar = false
            }"
        />

        <div>
          <router-link :to="{name: 'bots_list'}">
            <Button
                label="Личный кабинет"
                icon="pi pi-home"
                class="rounded"
            />
          </router-link>
        </div>
      </div>

      <div class="p-2">
        <router-view/>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import Image from "primevue/image";
import LeftSideBar from "@/components/view/SideBar/LeftSideBar.vue";
import {SideBarMenu} from "@/components/view/SideBar/sidebar";
import Button from "primevue/button";

export default {
  name: 'HowUse',
  components: {
    LeftSideBar,
    Image,
    Button
  },
  props: {
    section: {
      type: [String, null],
      required: false,
      default: null,
    }
  },
  data: function () {
    const menu = []

    // todo: сделать вложенное меню
    /*
        Каналы
          - отложенный постинг
          - перенаправление постов

        Группы
          - команды
          - приветствие
          - прощание
          - фильтр сообщений
          - статистика
          - триггеры

        Конструктор
          - описание функционала
          - описание блоков - сообщение, вопрос и т.д
     */

    menu.push(new SideBarMenu('О сервисе', 'doc_get_started', null, 'bx bx-run', []))
    menu.push(new SideBarMenu('Добавление бота', 'doc_how_to_add_bot', null, 'bx bx-bot', []))
    menu.push(new SideBarMenu('Постинг', 'doc_delay_publish', null, 'bx bx-text', []))
    menu.push(new SideBarMenu('Перенаправление постов', 'doc_forwarder', null, 'bx bx-fast-forward-circle', []))
    menu.push(new SideBarMenu('Функции для Telegram групп', 'doc_groups', null, 'bx bx-group', []))
    menu.push(new SideBarMenu('Переменные', 'doc_context', null, 'bx bx-memory-card', []))
    menu.push(new SideBarMenu('Теги', 'doc_tags', null, 'bx bx-purchase-tag', []))
    menu.push(new SideBarMenu('Бот обратной связи', 'doc_feedback_bot', null, 'pi pi-phone', []))
    menu.push(new SideBarMenu('Бизнес бот', 'doc_business_bot', null, 'pi pi pi-user', []))
    menu.push(new SideBarMenu('Конструктор', null, null, 'bx bx-git-merge', []))
    menu.push(
        new SideBarMenu('Блок - сообщение', 'doc_builder_message', null, 'bx bx-message-dots', []),
        new SideBarMenu('Блок - вопрос', 'doc_builder_question', null, 'pi pi-question', []),
        new SideBarMenu('Блок - действие', 'doc_builder_command', null, 'bx bx-wrench', []),
        new SideBarMenu('Блок - условие', 'doc_builder_trigger', null, 'bx bx-git-compare', []),
        new SideBarMenu('Блок - задержка', 'doc_builder_delay', null, 'bx bx-timer', []),
    )

    return {
      sideBarMenus: menu,
      hiddenSideBar: true,
    }
  },
}
</script>
